import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

// 현재 시간을 추적하는 bunja
export const currentTimeBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const currentTimeAtom = atom(Date.now());

  bunja.effect(() => {
    const interval = setInterval(() => {
      store.set(currentTimeAtom, Date.now());
    }, 1000);

    return () => clearInterval(interval);
  });
  return { currentTimeAtom };
});
currentTimeBunja.debugLabel = 'currentTimeBunja';
